interface TableBlockProps {
  headers: string[];
  rows: string[][];
  highlightRules?: Record<string, string>;
}

export function TableBlock({ headers, rows, highlightRules }: TableBlockProps) {
  const getCellClass = (cell: string): string => {
    if (!highlightRules) return "";
    for (const [pattern, className] of Object.entries(highlightRules)) {
      if (cell.toLowerCase().includes(pattern.toLowerCase())) {
        return className;
      }
    }
    return "";
  };

  return (
    <div className="overflow-x-auto rounded-xl border border-puntt-neutral-gray-6 shadow-sm">
      <table className="w-full text-sm">
        <thead className="sticky top-0 z-10">
          <tr className="border-b border-puntt-neutral-gray-6 bg-puntt-neutral-gray-3">
            {headers.map((header, idx) => (
              <th
                key={idx}
                className="px-4 py-2.5 text-left font-semibold text-puntt-neutral-gray-11"
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIdx) => (
            <tr
              key={rowIdx}
              className={`border-b border-puntt-neutral-gray-4 transition-colors last:border-b-0 hover:bg-puntt-accent-2/50 ${
                rowIdx % 2 === 1 ? "bg-puntt-neutral-gray-2" : "bg-base-white"
              }`}
            >
              {row.map((cell, cellIdx) => (
                <td
                  key={cellIdx}
                  className={`px-4 py-2.5 text-puntt-neutral-gray-12 ${getCellClass(cell)}`}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
